var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('router-link',{attrs:{"to":{
  name: 'app-PayPerView',
  params: { id: _vm.product.id },
}}},[_c('v-img',{staticClass:"white--background",attrs:{"src":_vm.product.image,"height":"100%","width":"100%","contain":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }